import {
	IconDefinition,
	faArrowDown,
	faArrowLeft,
	faArrowRight,
	faArrowRightFromBracket,
	faArrowUp,
	faBan,
	faBars,
	faBaseball,
	faBasketShopping,
	faBasketball,
	faBell,
	faBicycle,
	faBowlFood,
	faBowlingBall,
	faBullseye,
	faCakeCandles,
	faCalculator,
	faCalendar,
	faCalendarDays,
	faCalendarXmark,
	faCaretDown,
	faCartShopping,
	faChartLine,
	faCheck,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faCircleDown,
	faCircleInfo,
	faCircleQuestion,
	faClock,
	faClone,
	faCode,
	faComment,
	faCopy,
	faDatabase,
	faDownload,
	faDumbbell,
	faEarthAmerica,
	faEllipsis,
	faEllipsisVertical,
	faEnvelope,
	faEnvelopeCircleCheck,
	faExclamation,
	faEyeSlash,
	faFemale,
	faFile,
	faFilePdf,
	faFilter,
	faFire,
	faFireFlameSimple,
	faFloppyDisk,
	faFootball,
	faFutbol,
	faGear,
	faGenderless,
	faGlobe,
	faGolfBallTee,
	faHashtag,
	faHeading,
	faHockeyPuck,
	faHome,
	faIcons,
	faIdCard,
	faImagePortrait,
	faImages,
	faKey,
	faLightbulb,
	faLink,
	faListCheck,
	faLocationDot,
	faMagnifyingGlass,
	faMale,
	faMoneyCheck,
	faMoon,
	faNotEqual,
	faPalette,
	faPen,
	faPenToSquare,
	faPerson,
	faPersonArrowUpFromLine,
	faPersonHiking,
	faPersonRunning,
	faPersonSkating,
	faPersonSkiing,
	faPersonSwimming,
	faPlus,
	faPuzzlePiece,
	faQuestion,
	faQuoteLeft,
	faRankingStar,
	faRepeat,
	faRightToBracket,
	faRobot,
	faRocket,
	faSnowflake,
	faSpa,
	faStopwatch,
	faSun,
	faSwimmer,
	faTableTennis,
	faTerminal,
	faToolbox,
	faTrashCan,
	faTriangleExclamation,
	faUnlock,
	faUpload,
	faUser,
	faUserPen,
	faUsers,
	faUtensils,
	faVolleyball,
	faWeightScale,
	faXmark
} from '@fortawesome/free-solid-svg-icons';

export type IconSize = 'default' | 'large' | 'small' | 'extraLarge' | 'huge';
export type IconColor =
	| 'primary'
	| 'warning'
	| 'error'
	| 'success'
	| 'info'
	| 'tip'
	| 'default'
	| 'sideMenu'
	| 'onImage'
	| 'sideMenuActive';

export type IconType =
	| 'disabled'
	| 'genai'
	| 'copy'
	| 'question'
	| 'target'
	| 'snippet'
	| 'replace'
	| 'filters'
	| 'admin'
	| 'clear'
	| 'arrowRight'
	| 'upload'
	| 'circleInfo'
	| 'genderFemale'
	| 'genderMale'
	| 'genderLess'
	| 'idea'
	| 'arrowLeft'
	| 'referrer'
	| 'equipment'
	| 'number'
	| 'title'
	| 'id'
	| 'delete'
	| 'helpdesk'
	| 'calendarPast'
	| 'emailConfirm'
	| 'manage'
	| 'preview'
	| 'hide'
	| 'goBack'
	| 'rocket'
	| 'add'
	| 'bot'
	| 'design'
	| 'clone'
	| 'avatar'
	| 'remove'
	| 'error'
	| 'cancel'
	| 'bmi'
	| 'browser'
	| 'appUpdate'
	| 'save'
	| 'timezone'
	| 'tip'
	| 'theme'
	| 'link'
	| 'more'
	| 'menu'
	| 'password'
	| 'logout'
	| 'edit'
	| 'dashboard'
	| 'features'
	| 'email'
	| 'faq'
	| 'download_app'
	| 'map'
	| 'check'
	| 'weight'
	| 'branding'
	| 'user'
	| 'services'
	| 'calculator'
	| 'relativeTime'
	| 'pdf'
	| 'notes'
	| 'length'
	| 'purchase'
	| 'files'
	| 'gallery'
	| 'height'
	| 'notification'
	| 'select'
	| 'settings'
	| 'workoutActivity'
	| 'food'
	| 'arrowBack'
	| 'date'
	| 'arrowDown'
	| 'arrowUp'
	| 'users'
	| 'download'
	| 'analytics'
	| 'login'
	| 'workout'
	| 'diet'
	| 'close'
	| 'task'
	| 'upgrade'
	| 'caretDown'
	| 'dumbbell'
	| 'log'
	| 'calendar'
	| 'chevronRight'
	| 'comment'
	| 'done'
	| 'failed'
	| 'chevronDown'
	| 'birthdate'
	| 'volleyball'
	| 'hockey'
	| 'baseball'
	| 'bicycle'
	| 'stopwatch'
	| 'spa'
	| 'skiing'
	| 'skating'
	| 'tableTennis'
	| 'running'
	| 'hiking'
	| 'americanFootball'
	| 'soccer'
	| 'golf'
	| 'bowling'
	| 'basketball'
	| 'swimming'
	| 'flame'
	| 'user_pen'
	| 'info'
	| 'warmUp'
	| 'cooldown'
	| 'chevronLeft'
	| 'themeLight'
	| 'themeDark'
	| 'search'
	| 'dietMeal'
	| 'danger'
	| 'text'
	| 'exercises'
	| 'foods'
	| 'emoji'
	| 'moreHorizontal';

export const iconTransformation: Record<IconType, IconDefinition> = {
	arrowBack: faArrowLeft,
	question: faQuestion,
	genderFemale: faFemale,
	target: faBullseye,
	replace: faRepeat,
	filters: faFilter,
	upload: faUpload,
	clear: faXmark,
	genai: faTerminal,
	genderMale: faMale,
	genderLess: faGenderless,
	circleInfo: faCircleInfo,
	idea: faLightbulb,
	rocket: faRocket,
	calendarPast: faCalendarXmark,
	manage: faPenToSquare,
	title: faHeading,
	bot: faRobot,
	goBack: faArrowLeft,
	tip: faLightbulb,
	preview: faMagnifyingGlass,
	admin: faUnlock,
	snippet: faCode,
	timezone: faEarthAmerica,
	design: faPenToSquare,
	id: faIdCard,
	emoji: faIcons,
	emailConfirm: faEnvelopeCircleCheck,
	search: faMagnifyingGlass,
	number: faHashtag,
	chevronLeft: faChevronLeft,
	arrowLeft: faArrowLeft,
	equipment: faToolbox,
	arrowRight: faArrowRight,
	themeLight: faSun,
	browser: faGlobe,
	copy: faCopy,
	themeDark: faMoon,
	hide: faEyeSlash,
	helpdesk: faCircleQuestion,
	theme: faPalette,
	pdf: faFilePdf,
	danger: faExclamation,
	check: faCheck,
	add: faPlus,
	referrer: faMagnifyingGlass,
	faq: faQuestion,
	features: faPuzzlePiece,
	appUpdate: faCircleDown,
	analytics: faChartLine,
	avatar: faImagePortrait,
	clone: faClone,
	delete: faTrashCan,
	disabled: faNotEqual,
	text: faComment,
	menu: faBars,
	download: faFloppyDisk,
	edit: faPen,
	email: faEnvelope,
	download_app: faDownload,
	error: faTriangleExclamation,
	map: faLocationDot,
	more: faEllipsisVertical,
	moreHorizontal: faEllipsis,
	remove: faXmark,
	save: faFloppyDisk,
	select: faChevronRight,
	task: faListCheck,
	user: faUser,
	dumbbell: faDumbbell,
	calendar: faCalendar,
	birthdate: faCakeCandles,
	food: faUtensils,
	arrowUp: faArrowUp,
	arrowDown: faArrowDown,
	dietMeal: faBowlFood,
	chevronDown: faChevronDown,
	users: faUsers,
	dashboard: faHome,
	comment: faComment,
	chevronRight: faChevronRight,
	notification: faBell,
	upgrade: faCartShopping,
	login: faRightToBracket,
	workout: faDumbbell,
	diet: faUtensils,
	caretDown: faCaretDown,
	close: faXmark,
	branding: faRankingStar,
	services: faMoneyCheck,
	date: faCalendarDays,
	relativeTime: faClock,
	notes: faQuoteLeft,
	length: faStopwatch,
	done: faCheck,
	failed: faXmark,
	log: faDatabase,
	workoutActivity: faSwimmer,
	volleyball: faVolleyball,
	hockey: faHockeyPuck,
	baseball: faBaseball,
	bicycle: faBicycle,
	stopwatch: faStopwatch,
	spa: faSpa,
	skiing: faPersonSkiing,
	skating: faPersonSkating,
	tableTennis: faTableTennis,
	running: faPersonRunning,
	hiking: faPersonHiking,
	americanFootball: faFootball,
	soccer: faFutbol,
	golf: faGolfBallTee,
	bowling: faBowlingBall,
	basketball: faBasketball,
	swimming: faPersonSwimming,
	flame: faFireFlameSimple,
	weight: faWeightScale,
	height: faPersonArrowUpFromLine,
	user_pen: faUserPen,
	calculator: faCalculator,
	files: faFile,
	gallery: faImages,
	cancel: faBan,
	info: faCircleInfo,
	settings: faGear,
	logout: faArrowRightFromBracket,
	link: faLink,
	purchase: faBasketShopping,
	bmi: faPerson,
	warmUp: faFire,
	cooldown: faSnowflake,
	password: faKey,
	exercises: faDatabase,
	foods: faDatabase
};
